var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 680,
    viewBox: "0 0 1024 680",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1024 0H0V680H1024V0Z",
    fill: "#090F30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1015.74 406.25V410.38H999.23V414.5H978.58V418.62H916.65V414.5H891.87V410.38H871.23V406.25H854.71V402.13H842.32V398H834.06V393.88H825.81V389.75H817.55V385.63H809.29V381.51H801V377.38H796.9V373.26H788.65V369.14H780.39V365H772.13V360.9H768V356.78H755.61V352.66H747.35V348.53H739.1V344.41H726.71V340.29H718.45V336.16H706.06V332H697.81V327.88H689.55V323.8H685.42V319.67H673V315.55H664.74V311.43H652.39V307.3H640V303.18H623.48V299.06H607V294.94H586.32V290.81H479V294.94H446V299.06H413V303.18H384V307.3H367.48V311.43H351V315.55H338.58V319.67H322.06V323.8H301.42V327.92H289V332H272.52V336.12H260.13V340.25H247.74V344.37H239.48V348.49H218.84V352.62H194.06V356.74H177.55V360.86H123.87V356.74H82.58V352.62H53.68V348.49H37.16V344.37H0V356.74H16.52V360.86H45.42V365H70.19V369.12H90.84V373.24H111.48V377.36H148.65V381.49H218.84V377.36H235.35V373.24H247.74V369.12H268.39V365H346.84V369.12H363.35V373.24H367.48V377.36H371.61V381.49H375.74V389.73H379.87V406.22H375.74V414.47H371.61V418.59H367.48V422.72H355.1V426.84H334.45V431H251.87V426.88H218.87V422.76H202.32V418.63H189.94V414.5H177.55V410.38H161V406.25H144.52V402.13H119.74V398H70.19V402.12H37.19V406.24H0V443.35H12.39V439.23H45.39V435.11H103.2V439.23H111.45V443.35H119.71V447.47H136.23V451.6H144.49V455.72H156.9V459.84H169.29V464H177.55V468.12H189.94V472.24H202.32V476.36H218.84V480.49H305.55V476.36H326.19V472.24H342.71V468.1H355.1V464H371.61V459.87H375.74V455.75H384V451.63H392.26V447.5H400.52V443.38H408.77V439.26H417V435.14H425.26V431H437.65V426.88H450.03V422.76H458.29V418.63H466.55V414.5H483.1V410.38H495.48V406.25H516.13V402.13H528.52V398H540.9V393.88H557.42V389.75H578.06V385.63H693.68V389.75H710.19V393.88H726.71V398H743.23V402.12H755.61V406.24H772.13V410.37H784.52V414.49H801V418.61H809.26V422.74H825.78V426.86H842.29V431H867.1V435.13H929V439.25H978.55V443.37H1024V406.25H1015.74ZM470.74 323.8H545V327.92H578V332H607V336.12H619.38V340.25H627.64V344.37H586.32V348.49H573.94V352.62H561.55V356.74H549.16V360.86H532.65V365H516.13V369.12H487.23V373.24H454.23V369.12H437.68V365H429.42V360.9H425.29V356.78H421.16V348.53H425.29V340.29H429.42V336.16H433.55V332H437.68V327.88H450.06V323.8H470.71H470.74Z",
    fill: "#7B9CFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1019.87 348.53H1015.74H1011.61H1007.48H1003.36V352.66H999.23H995.1H990.97V356.78H986.84H982.71H978.58V360.9H974.45H970.32H966.19V365.02H962.07H957.94H953.81H949.68H945.55V369.15H941.42H937.29H933.16V373.27H929.03H924.9H920.77H916.64H912.52H908.39V377.39H912.52H916.64H920.77H924.9H929.03H933.16H937.29H941.42H945.55V373.27H949.68H953.81H957.94H962.07H966.19H970.32H974.45H978.58V369.15H982.71H986.84H990.97V365.02H995.1H999.23H1003.36V360.9H1007.48H1011.61H1015.74H1019.87H1024V356.78V352.66V348.53H1019.87Z",
    fill: "#7B9CFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1019.87 200.11H970.32V204.23H957.94V208.35H937.29V212.48H920.77V216.6H896V220.72H879.48V224.85H858.84V229H817.55V233.12H776.26V237.24H706.06V241.37H644.13V237.24H602.84V233.12H578.06V229H545V224.88H520.26V220.75H507.87V216.6H487.23V212.48H466.58V208.35H429.42V204.23H392.26V200.11H256V204.23H214.71V208.35H136.26V212.48H90.84V208.35H53.68V204.23H16.52V200.11H0V278.44H24.77V282.57H45.42V286.69H95V282.57H119.77V278.44H136.29V274.32H173.45V270.2H194.09V266.08H210.61V262H227.1V257.88H243.61V253.76H264.26V249.63H280.77V245.51H297.29V241.39H317.94V237.26H342.71V233.14H367.48V229H417V233.12H445.91V237.24H478.91V241.37H516.07V245.49H536.71V249.61H565.62V253.74H582.13V257.86H590.39V262H607V266.13H615.26V270.25H627.64V274.37H640V278.49H648.26V282.62H660.65V286.74H668.9V290.86H685.42V294.99H697.81V299.11H718.45V303.23H730.84V307.35H755.61V311.48H792.77V315.6H896V311.48H916.65V307.3H929V303.18H945.52V299.06H957.91V294.94H974.42V290.81H986.81V286.69H999.2V282.57H1015.71V278.44H1024V200.11H1019.87ZM726.71 262H763.87V266.13H768V270.25H759.74V274.37H714.32V270.2H701.94V266.08H689.55V262H726.71ZM16.52 257.83V245.46H20.65V241.34H41.29V237.21H70.19V233.09H181.68V237.21H165.16V241.34H152.77V245.46H144.52V249.58H128V253.71H119.74V257.83H99.1V262H20.65V257.88L16.52 257.83ZM1019.87 233.09H1011.61V237.21H1003.35V241.34H995.1V245.46H986.84V249.58H978.58V253.71H974.45V257.83H970.32V262H962.06V266.13H953.81V270.25H941.42V274.37H924.9V278.49H908.39V282.62H891.87V286.74H829.94V282.62H813.42V278.49H805.16V274.37H801V270.2H805.13V266.08H817.52V262H854.68V257.88H879.45V253.76H900.1V249.63H912.49V245.51H924.9V241.39H953.81V237.26H974.45V233.14H991V229H1019.9L1019.87 233.09Z",
    fill: "#AD8BFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M368.14 186.97H364.02V191.09H368.14V186.97Z",
    fill: "#D2ED65"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M335.14 116.95H331.02V121.07H335.14V116.95Z",
    fill: "#71DDF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M322.76 145.79H318.64V149.91H322.76V145.79Z",
    fill: "#D2ED65"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M351.64 182.85H347.52V186.97H351.64V182.85Z",
    fill: "#D2ED65"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M265.01 125.19H260.89V129.31H265.01V125.19Z",
    fill: "#D2ED65"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M306.26 104.6H302.14V108.72H306.26V104.6Z",
    fill: "#00AEC9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M281.51 51.05H277.39V55.17H281.51V51.05Z",
    fill: "#00AEC9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M244.39 178.74H240.27V182.86H244.39V178.74Z",
    fill: "#00AEC9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M166.01 88.12H161.89V92.24H166.01V88.12Z",
    fill: "#71DDF0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M265.01 30.46H260.89V34.58H265.01V30.46Z",
    fill: "#71DDF0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M87.64 162.26H83.52V166.38H87.64V162.26Z",
    fill: "#00AEC9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.02 51.05H62.9V55.17H67.02V51.05Z",
    fill: "#D2ED65"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M368.14 137.55H364.02V141.67H368.14V137.55Z",
    fill: "#00AEC9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.14 170.5H34.02V174.62H38.14V170.5Z",
    fill: "#D2ED65"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M252.64 203.45H248.52V207.57H252.64V203.45Z",
    fill: "#D2ED65"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M306.26 162.26H302.14V166.38H306.26V162.26Z",
    fill: "#71DDF0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M322.76 63.41H318.64V67.53H322.76V63.41Z",
    fill: "#71DDF0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M331.01 203.45H326.89V207.57H331.01V203.45Z",
    fill: "#D2ED65"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M91.77 22.22H87.65V26.34H91.77V22.22Z",
    fill: "#00AEC9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M108.27 42.81H104.15V46.93H108.27V42.81Z",
    fill: "#00AEC9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.64 79.88H17.52V84H21.64V79.88Z",
    fill: "#D2ED65"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M95.89 5.73999H91.77V9.85999H95.89V5.73999Z",
    fill: "#00AEC9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M50.52 207.57H46.4V211.69H50.52V207.57Z",
    fill: "#00AEC9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M170.14 5.73999H166.02V9.85999H170.14V5.73999Z",
    fill: "#D2ED65"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M133.01 9.86002H128.89V13.98H133.01V9.86002Z",
    fill: "#00AEC9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M277.39 162.26H273.27V166.38H277.39V162.26Z",
    fill: "#D2ED65"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M219.64 129.31H215.52V133.43H219.64V129.31Z",
    fill: "#D2ED65"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M46.39 30.46H42.27V34.58H46.39V30.46Z",
    fill: "#71DDF0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M190.76 116.95H186.64V121.07H190.76V116.95Z",
    fill: "#00AEC9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M83.52 79.88H79.4V84H83.52V79.88Z",
    fill: "#00AEC9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27002 186.97H5.15002V191.09H9.27002V186.97Z",
    fill: "#71DDF0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M372.26 236.4H368.14V240.52H372.26V236.4Z",
    fill: "#D2ED65"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M112.39 84H108.27V88.12H112.39V84Z",
    fill: "#00AEC9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M13.39 149.9H9.27002V154.02H13.39V149.9Z",
    fill: "#71DDF0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M104.14 211.69H100.02V215.81H104.14V211.69Z",
    fill: "#00AEC9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M252.64 75.76H248.52V79.88H252.64V75.76Z",
    fill: "#D2ED65"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M21.64 34.58H17.52V38.7H21.64V34.58Z",
    fill: "#00AEC9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M199.01 182.85H194.89V186.97H199.01V182.85Z",
    fill: "#71DDF0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M269.14 100.48H265.02V104.6H269.14V100.48Z",
    fill: "#00AEC9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M157.76 195.21H153.64V199.33H157.76V195.21Z",
    fill: "#00AEC9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M203.14 228.16H199.02V232.28H203.14V228.16Z",
    fill: "#71DDF0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M91.77 133.43H87.65V137.55H91.77V133.43Z",
    fill: "#71DDF0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M240.26 30.46H236.14V34.58H240.26V30.46Z",
    fill: "#00AEC9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M368.14 46.93H364.02V51.05H368.14V46.93Z",
    fill: "#71DDF0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M190.76 63.41H186.64V67.53H190.76V63.41Z",
    fill: "#71DDF0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M116.51 178.74H112.39V182.86H116.51V178.74Z",
    fill: "#71DDF0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M71.14 112.83H67.02V116.95H71.14V112.83Z",
    fill: "#00AEC9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14002 51.05H1.02002V55.17H5.14002V51.05Z",
    fill: "#00AEC9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M120.64 112.83H116.52V116.95H120.64V112.83Z",
    fill: "#D2ED65"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M351.64 88.12H347.52V92.24H351.64V88.12Z",
    fill: "#00AEC9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M95.89 26.34H91.77V30.46H95.89V26.34Z",
    fill: "#00AEC9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M112.39 1.63H108.27V5.75H112.39V1.63Z",
    fill: "#00AEC9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M149.51 18.1H145.39V22.22H149.51V18.1Z",
    fill: "#D2ED65"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M54.64 5.73999H50.52V9.85999H54.64V5.73999Z",
    fill: "#00AEC9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M116.51 42.81H112.39V46.93H116.51V42.81Z",
    fill: "#71DDF0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M87.64 1.63H83.52V5.75H87.64V1.63Z",
    fill: "#D2ED65"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M95.89 71.65H91.77V75.77H95.89V71.65Z",
    fill: "#D2ED65"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14002 96.36H1.02002V100.48H5.14002V96.36Z",
    fill: "#D2ED65"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M38.14 121.07H34.02V125.19H38.14V121.07Z",
    fill: "#71DDF0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M54.64 133.43H50.52V137.55H54.64V133.43Z",
    fill: "#71DDF0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M38.14 42.81H34.02V46.93H38.14V42.81Z",
    fill: "#71DDF0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M67.02 158.14H62.9V162.26H67.02V158.14Z",
    fill: "#00AEC9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M17.52 186.97H13.4V191.09H17.52V186.97Z",
    fill: "#71DDF0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27002 1.63H5.15002V5.75H9.27002V1.63Z",
    fill: "#00AEC9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M54.64 79.88H50.52V84H54.64V79.88Z",
    fill: "#00AEC9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M298.01 129.31H293.89V133.43H298.01V129.31Z",
    fill: "#7D7BFF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M293.89 129.31H289.77V133.43H293.89V129.31Z",
    fill: "#7D7BFF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M289.76 137.55H285.64V141.67H289.76V137.55Z",
    fill: "#7D7BFF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M289.76 133.43H285.64V137.55H289.76V133.43Z",
    fill: "#7D7BFF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M289.76 125.19H285.64V129.31H289.76V125.19Z",
    fill: "#7D7BFF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M289.76 121.07H285.64V125.19H289.76V121.07Z",
    fill: "#7D7BFF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M285.64 129.31H281.52V133.43H285.64V129.31Z",
    fill: "#7D7BFF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M281.51 129.31H277.39V133.43H281.51V129.31Z",
    fill: "#7D7BFF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M128.89 232.28H124.77V236.4H128.89V232.28Z",
    fill: "#26DEFF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M124.76 240.52H120.64V244.64H124.76V240.52Z",
    fill: "#26DEFF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M124.76 236.4H120.64V240.52H124.76V236.4Z",
    fill: "#26DEFF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M124.76 228.16H120.64V232.28H124.76V228.16Z",
    fill: "#26DEFF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M124.76 224.04H120.64V228.16H124.76V224.04Z",
    fill: "#26DEFF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M120.64 232.28H116.52V236.4H120.64V232.28Z",
    fill: "#26DEFF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M29.89 18.1H25.77V22.22H29.89V18.1Z",
    fill: "#7D7BFF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M25.77 22.22H21.65V26.34H25.77V22.22Z",
    fill: "#7D7BFF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M25.77 13.98H21.65V18.1H25.77V13.98Z",
    fill: "#7D7BFF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M21.64 18.1H17.52V22.22H21.64V18.1Z",
    fill: "#7D7BFF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M149.51 42.81H145.39V46.93H149.51V42.81Z",
    fill: "#6976FF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M145.39 46.93H141.27V51.05H145.39V46.93Z",
    fill: "#6976FF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M145.39 38.7H141.27V42.82H145.39V38.7Z",
    fill: "#6976FF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M141.26 42.81H137.14V46.93H141.26V42.81Z",
    fill: "#6976FF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M302.14 207.57H298.02V211.69H302.14V207.57Z",
    fill: "#F1FF4D"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M298.01 211.69H293.89V215.81H298.01V211.69Z",
    fill: "#F1FF4D"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M298.01 207.57H293.89V211.69H298.01V207.57Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M298.01 203.45H293.89V207.57H298.01V203.45Z",
    fill: "#F1FF4D"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M293.89 207.57H289.77V211.69H293.89V207.57Z",
    fill: "#F1FF4D"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M331.01 22.22H326.89V26.34H331.01V22.22Z",
    fill: "#008DF0"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M343.39 26.34H339.27V30.46H343.39V26.34Z",
    fill: "#008DF0"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M339.26 30.46H335.14V34.58H339.26V30.46Z",
    fill: "#008DF0"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M339.26 26.34H335.14V30.46H339.26V26.34Z",
    fill: "#52B7FF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M339.26 22.22H335.14V26.34H339.26V22.22Z",
    fill: "#008DF0"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M335.14 34.58H331.02V38.7H335.14V34.58Z",
    fill: "#008DF0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M335.14 30.46H331.02V34.58H335.14V30.46Z",
    fill: "#52B7FF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M335.14 26.34H331.02V30.46H335.14V26.34Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M335.14 22.22H331.02V26.34H335.14V22.22Z",
    fill: "#52B7FF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M335.14 18.1H331.02V22.22H335.14V18.1Z",
    fill: "#008DF0"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M331.01 30.46H326.89V34.58H331.01V30.46Z",
    fill: "#008DF0"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M331.01 26.34H326.89V30.46H331.01V26.34Z",
    fill: "#52B7FF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M326.89 26.34H322.77V30.46H326.89V26.34Z",
    fill: "#008DF0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M54.64 100.48H50.52V104.6H54.64V100.48Z",
    fill: "#008DF0"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M67.02 104.6H62.9V108.72H67.02V104.6Z",
    fill: "#008DF0"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M62.89 108.72H58.77V112.84H62.89V108.72Z",
    fill: "#008DF0"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M62.89 104.6H58.77V108.72H62.89V104.6Z",
    fill: "#52B7FF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M62.89 100.48H58.77V104.6H62.89V100.48Z",
    fill: "#008DF0"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M58.77 112.83H54.65V116.95H58.77V112.83Z",
    fill: "#008DF0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M58.77 108.72H54.65V112.84H58.77V108.72Z",
    fill: "#52B7FF"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M58.77 104.6H54.65V108.72H58.77V104.6Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M58.77 100.48H54.65V104.6H58.77V100.48Z",
    fill: "#52B7FF"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M58.77 96.36H54.65V100.48H58.77V96.36Z",
    fill: "#008DF0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M54.64 108.72H50.52V112.84H54.64V108.72Z",
    fill: "#008DF0"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M54.64 104.6H50.52V108.72H54.64V104.6Z",
    fill: "#52B7FF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M50.52 104.6H46.4V108.72H50.52V104.6Z",
    fill: "#008DF0"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M751.76 186.97H747.64V191.09H751.76V186.97Z",
    fill: "#D2ED65"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M718.76 116.95H714.64V121.07H718.76V116.95Z",
    fill: "#71DDF0"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M706.38 145.79H702.26V149.91H706.38V145.79Z",
    fill: "#D2ED65"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M735.26 182.85H731.14V186.97H735.26V182.85Z",
    fill: "#D2ED65"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M648.63 125.19H644.51V129.31H648.63V125.19Z",
    fill: "#D2ED65"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M689.88 104.6H685.76V108.72H689.88V104.6Z",
    fill: "#00AEC9"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M665.13 51.05H661.01V55.17H665.13V51.05Z",
    fill: "#00AEC9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M628.01 178.74H623.89V182.86H628.01V178.74Z",
    fill: "#00AEC9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M549.63 88.12H545.51V92.24H549.63V88.12Z",
    fill: "#71DDF0"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M648.63 30.46H644.51V34.58H648.63V30.46Z",
    fill: "#71DDF0"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M471.26 162.26H467.14V166.38H471.26V162.26Z",
    fill: "#00AEC9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M450.63 51.05H446.51V55.17H450.63V51.05Z",
    fill: "#D2ED65"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M751.76 137.55H747.64V141.67H751.76V137.55Z",
    fill: "#00AEC9"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M421.76 170.5H417.64V174.62H421.76V170.5Z",
    fill: "#D2ED65"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M636.26 203.45H632.14V207.57H636.26V203.45Z",
    fill: "#D2ED65"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M689.88 162.26H685.76V166.38H689.88V162.26Z",
    fill: "#71DDF0"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M706.38 63.41H702.26V67.53H706.38V63.41Z",
    fill: "#71DDF0"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M714.63 203.45H710.51V207.57H714.63V203.45Z",
    fill: "#D2ED65"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M475.38 22.22H471.26V26.34H475.38V22.22Z",
    fill: "#00AEC9"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M491.88 42.81H487.76V46.93H491.88V42.81Z",
    fill: "#00AEC9"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M405.26 79.88H401.14V84H405.26V79.88Z",
    fill: "#D2ED65"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M479.51 5.73999H475.39V9.85999H479.51V5.73999Z",
    fill: "#00AEC9"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M434.14 207.57H430.02V211.69H434.14V207.57Z",
    fill: "#00AEC9"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M553.76 5.73999H549.64V9.85999H553.76V5.73999Z",
    fill: "#D2ED65"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M516.63 9.86002H512.51V13.98H516.63V9.86002Z",
    fill: "#00AEC9"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M661.01 162.26H656.89V166.38H661.01V162.26Z",
    fill: "#D2ED65"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M603.26 129.31H599.14V133.43H603.26V129.31Z",
    fill: "#D2ED65"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M430.01 30.46H425.89V34.58H430.01V30.46Z",
    fill: "#71DDF0"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M574.38 116.95H570.26V121.07H574.38V116.95Z",
    fill: "#00AEC9"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M467.13 79.88H463.01V84H467.13V79.88Z",
    fill: "#00AEC9"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M392.89 186.97H388.77V191.09H392.89V186.97Z",
    fill: "#71DDF0"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M755.88 236.4H751.76V240.52H755.88V236.4Z",
    fill: "#D2ED65"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M496.01 84H491.89V88.12H496.01V84Z",
    fill: "#00AEC9"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M397.01 149.9H392.89V154.02H397.01V149.9Z",
    fill: "#71DDF0"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M487.76 211.69H483.64V215.81H487.76V211.69Z",
    fill: "#00AEC9"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M636.26 75.76H632.14V79.88H636.26V75.76Z",
    fill: "#D2ED65"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M405.26 34.58H401.14V38.7H405.26V34.58Z",
    fill: "#00AEC9"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M582.63 182.85H578.51V186.97H582.63V182.85Z",
    fill: "#71DDF0"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M652.76 100.48H648.64V104.6H652.76V100.48Z",
    fill: "#00AEC9"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M541.38 195.21H537.26V199.33H541.38V195.21Z",
    fill: "#00AEC9"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M586.76 228.16H582.64V232.28H586.76V228.16Z",
    fill: "#71DDF0"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M475.38 133.43H471.26V137.55H475.38V133.43Z",
    fill: "#71DDF0"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M623.88 30.46H619.76V34.58H623.88V30.46Z",
    fill: "#00AEC9"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M751.76 46.93H747.64V51.05H751.76V46.93Z",
    fill: "#71DDF0"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M574.38 63.41H570.26V67.53H574.38V63.41Z",
    fill: "#71DDF0"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M500.13 178.74H496.01V182.86H500.13V178.74Z",
    fill: "#71DDF0"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M454.76 112.83H450.64V116.95H454.76V112.83Z",
    fill: "#00AEC9"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M388.76 51.05H384.64V55.17H388.76V51.05Z",
    fill: "#00AEC9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M504.26 112.83H500.14V116.95H504.26V112.83Z",
    fill: "#D2ED65"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M735.26 88.12H731.14V92.24H735.26V88.12Z",
    fill: "#00AEC9"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M479.51 26.34H475.39V30.46H479.51V26.34Z",
    fill: "#00AEC9"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M496.01 1.63H491.89V5.75H496.01V1.63Z",
    fill: "#00AEC9"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M533.13 18.1H529.01V22.22H533.13V18.1Z",
    fill: "#D2ED65"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M438.26 5.73999H434.14V9.85999H438.26V5.73999Z",
    fill: "#00AEC9"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M500.13 42.81H496.01V46.93H500.13V42.81Z",
    fill: "#71DDF0"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M479.51 108.72H475.39V112.84H479.51V108.72Z",
    fill: "#00AEC9"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M471.26 1.63H467.14V5.75H471.26V1.63Z",
    fill: "#D2ED65"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M479.51 71.65H475.39V75.77H479.51V71.65Z",
    fill: "#D2ED65"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M388.76 96.36H384.64V100.48H388.76V96.36Z",
    fill: "#D2ED65"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M421.76 121.07H417.64V125.19H421.76V121.07Z",
    fill: "#71DDF0"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M438.26 133.43H434.14V137.55H438.26V133.43Z",
    fill: "#71DDF0"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M421.76 42.81H417.64V46.93H421.76V42.81Z",
    fill: "#71DDF0"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M450.63 158.14H446.51V162.26H450.63V158.14Z",
    fill: "#00AEC9"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M401.14 186.97H397.02V191.09H401.14V186.97Z",
    fill: "#71DDF0"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M392.89 1.63H388.77V5.75H392.89V1.63Z",
    fill: "#00AEC9"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M438.26 79.88H434.14V84H438.26V79.88Z",
    fill: "#00AEC9"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M681.63 129.31H677.51V133.43H681.63V129.31Z",
    fill: "#7D7BFF"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M677.51 129.31H673.39V133.43H677.51V129.31Z",
    fill: "#7D7BFF"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M673.38 137.55H669.26V141.67H673.38V137.55Z",
    fill: "#7D7BFF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M673.38 133.43H669.26V137.55H673.38V133.43Z",
    fill: "#7D7BFF"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M673.38 125.19H669.26V129.31H673.38V125.19Z",
    fill: "#7D7BFF"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M673.38 121.07H669.26V125.19H673.38V121.07Z",
    fill: "#7D7BFF"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M669.26 129.31H665.14V133.43H669.26V129.31Z",
    fill: "#7D7BFF"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M665.13 129.31H661.01V133.43H665.13V129.31Z",
    fill: "#7D7BFF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M549.63 228.16H545.51V232.28H549.63V228.16Z",
    fill: "#26DEFF"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M545.51 236.4H541.39V240.52H545.51V236.4Z",
    fill: "#26DEFF"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M545.51 232.28H541.39V236.4H545.51V232.28Z",
    fill: "#26DEFF"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M545.51 224.04H541.39V228.16H545.51V224.04Z",
    fill: "#26DEFF"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M545.51 219.92H541.39V224.04H545.51V219.92Z",
    fill: "#26DEFF"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M541.38 228.16H537.26V232.28H541.38V228.16Z",
    fill: "#26DEFF"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M413.51 18.1H409.39V22.22H413.51V18.1Z",
    fill: "#7D7BFF"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M409.39 22.22H405.27V26.34H409.39V22.22Z",
    fill: "#7D7BFF"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M409.39 13.98H405.27V18.1H409.39V13.98Z",
    fill: "#7D7BFF"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M405.26 18.1H401.14V22.22H405.26V18.1Z",
    fill: "#7D7BFF"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M533.13 42.81H529.01V46.93H533.13V42.81Z",
    fill: "#6976FF"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M529.01 46.93H524.89V51.05H529.01V46.93Z",
    fill: "#6976FF"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M529.01 38.7H524.89V42.82H529.01V38.7Z",
    fill: "#6976FF"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M524.88 42.81H520.76V46.93H524.88V42.81Z",
    fill: "#6976FF"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M685.76 207.57H681.64V211.69H685.76V207.57Z",
    fill: "#F1FF4D"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M681.63 211.69H677.51V215.81H681.63V211.69Z",
    fill: "#F1FF4D"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M681.63 207.57H677.51V211.69H681.63V207.57Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M681.63 203.45H677.51V207.57H681.63V203.45Z",
    fill: "#F1FF4D"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M677.51 207.57H673.39V211.69H677.51V207.57Z",
    fill: "#F1FF4D"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M714.63 22.22H710.51V26.34H714.63V22.22Z",
    fill: "#008DF0"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M727.01 26.34H722.89V30.46H727.01V26.34Z",
    fill: "#008DF0"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M722.88 30.46H718.76V34.58H722.88V30.46Z",
    fill: "#008DF0"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M722.88 26.34H718.76V30.46H722.88V26.34Z",
    fill: "#52B7FF"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M722.88 22.22H718.76V26.34H722.88V22.22Z",
    fill: "#008DF0"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M718.76 34.58H714.64V38.7H718.76V34.58Z",
    fill: "#008DF0"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M718.76 30.46H714.64V34.58H718.76V30.46Z",
    fill: "#52B7FF"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M718.76 26.34H714.64V30.46H718.76V26.34Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M718.76 22.22H714.64V26.34H718.76V22.22Z",
    fill: "#52B7FF"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M718.76 18.1H714.64V22.22H718.76V18.1Z",
    fill: "#008DF0"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M714.63 30.46H710.51V34.58H714.63V30.46Z",
    fill: "#008DF0"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M714.63 26.34H710.51V30.46H714.63V26.34Z",
    fill: "#52B7FF"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M710.51 26.34H706.39V30.46H710.51V26.34Z",
    fill: "#008DF0"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M438.26 100.48H434.14V104.6H438.26V100.48Z",
    fill: "#008DF0"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M450.63 104.6H446.51V108.72H450.63V104.6Z",
    fill: "#008DF0"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M446.51 108.72H442.39V112.84H446.51V108.72Z",
    fill: "#008DF0"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M446.51 104.6H442.39V108.72H446.51V104.6Z",
    fill: "#52B7FF"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M446.51 100.48H442.39V104.6H446.51V100.48Z",
    fill: "#008DF0"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M442.39 112.83H438.27V116.95H442.39V112.83Z",
    fill: "#008DF0"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M442.39 108.72H438.27V112.84H442.39V108.72Z",
    fill: "#52B7FF"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M442.39 104.6H438.27V108.72H442.39V104.6Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M442.39 100.48H438.27V104.6H442.39V100.48Z",
    fill: "#52B7FF"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M442.39 96.36H438.27V100.48H442.39V96.36Z",
    fill: "#008DF0"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M438.26 108.72H434.14V112.84H438.26V108.72Z",
    fill: "#008DF0"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M438.26 104.6H434.14V108.72H438.26V104.6Z",
    fill: "#52B7FF"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M434.14 104.6H430.02V108.72H434.14V104.6Z",
    fill: "#008DF0"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.75 125.19H1011.63V129.31H1015.75V125.19Z",
    fill: "#D2ED65"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M995.13 178.74H991.01V182.86H995.13V178.74Z",
    fill: "#00AEC9"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M916.75 88.12H912.63V92.24H916.75V88.12Z",
    fill: "#71DDF0"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M945.54 28.4H941.42V32.52H945.54V28.4Z",
    fill: "#71DDF0"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M838.38 162.26H834.26V166.38H838.38V162.26Z",
    fill: "#00AEC9"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M817.75 51.05H813.63V55.17H817.75V51.05Z",
    fill: "#D2ED65"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M788.88 170.5H784.76V174.62H788.88V170.5Z",
    fill: "#D2ED65"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.38 203.45H999.26V207.57H1003.38V203.45Z",
    fill: "#D2ED65"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M842.5 22.22H838.38V26.34H842.5V22.22Z",
    fill: "#00AEC9"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M859 42.81H854.88V46.93H859V42.81Z",
    fill: "#00AEC9"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M772.38 79.88H768.26V84H772.38V79.88Z",
    fill: "#D2ED65"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M846.63 5.73999H842.51V9.85999H846.63V5.73999Z",
    fill: "#00AEC9"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M801.25 207.57H797.13V211.69H801.25V207.57Z",
    fill: "#00AEC9"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M920.88 5.73999H916.76V9.85999H920.88V5.73999Z",
    fill: "#D2ED65"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M883.75 9.86002H879.63V13.98H883.75V9.86002Z",
    fill: "#00AEC9"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M970.38 129.31H966.26V133.43H970.38V129.31Z",
    fill: "#D2ED65"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M797.13 30.46H793.01V34.58H797.13V30.46Z",
    fill: "#71DDF0"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M941.5 116.95H937.38V121.07H941.5V116.95Z",
    fill: "#00AEC9"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M834.25 79.88H830.13V84H834.25V79.88Z",
    fill: "#00AEC9"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M760.01 186.97H755.89V191.09H760.01V186.97Z",
    fill: "#71DDF0"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M863.13 84H859.01V88.12H863.13V84Z",
    fill: "#00AEC9"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M764.13 149.9H760.01V154.02H764.13V149.9Z",
    fill: "#71DDF0"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M854.88 211.69H850.76V215.81H854.88V211.69Z",
    fill: "#00AEC9"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.38 75.76H999.26V79.88H1003.38V75.76Z",
    fill: "#D2ED65"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M772.38 34.58H768.26V38.7H772.38V34.58Z",
    fill: "#00AEC9"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M949.75 182.85H945.63V186.97H949.75V182.85Z",
    fill: "#71DDF0"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.88 100.48H1015.76V104.6H1019.88V100.48Z",
    fill: "#00AEC9"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M908.5 195.21H904.38V199.33H908.5V195.21Z",
    fill: "#00AEC9"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M953.88 228.16H949.76V232.28H953.88V228.16Z",
    fill: "#71DDF0"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M842.5 133.43H838.38V137.55H842.5V133.43Z",
    fill: "#71DDF0"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M941.5 63.41H937.38V67.53H941.5V63.41Z",
    fill: "#71DDF0"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M867.25 178.74H863.13V182.86H867.25V178.74Z",
    fill: "#71DDF0"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M821.88 112.83H817.76V116.95H821.88V112.83Z",
    fill: "#00AEC9"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M755.88 51.05H751.76V55.17H755.88V51.05Z",
    fill: "#00AEC9"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M871.38 112.83H867.26V116.95H871.38V112.83Z",
    fill: "#D2ED65"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M846.63 26.34H842.51V30.46H846.63V26.34Z",
    fill: "#00AEC9"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M863.13 1.63H859.01V5.75H863.13V1.63Z",
    fill: "#00AEC9"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M900.25 18.1H896.13V22.22H900.25V18.1Z",
    fill: "#D2ED65"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M805.38 5.73999H801.26V9.85999H805.38V5.73999Z",
    fill: "#00AEC9"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M867.25 42.81H863.13V46.93H867.25V42.81Z",
    fill: "#71DDF0"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M846.63 108.72H842.51V112.84H846.63V108.72Z",
    fill: "#00AEC9"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M838.38 1.63H834.26V5.75H838.38V1.63Z",
    fill: "#D2ED65"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M846.63 71.65H842.51V75.77H846.63V71.65Z",
    fill: "#D2ED65"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M755.88 96.36H751.76V100.48H755.88V96.36Z",
    fill: "#D2ED65"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M788.88 121.07H784.76V125.19H788.88V121.07Z",
    fill: "#71DDF0"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M805.38 133.43H801.26V137.55H805.38V133.43Z",
    fill: "#71DDF0"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M788.88 42.81H784.76V46.93H788.88V42.81Z",
    fill: "#71DDF0"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M817.75 158.14H813.63V162.26H817.75V158.14Z",
    fill: "#00AEC9"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M768.26 186.97H764.14V191.09H768.26V186.97Z",
    fill: "#71DDF0"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M760.01 1.63H755.89V5.75H760.01V1.63Z",
    fill: "#00AEC9"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M805.38 79.88H801.26V84H805.38V79.88Z",
    fill: "#00AEC9"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M892 224.04H887.88V228.16H892V224.04Z",
    fill: "#26DEFF"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M887.88 232.28H883.76V236.4H887.88V232.28Z",
    fill: "#26DEFF"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M887.88 228.16H883.76V232.28H887.88V228.16Z",
    fill: "#26DEFF"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M887.88 219.92H883.76V224.04H887.88V219.92Z",
    fill: "#26DEFF"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M887.88 215.81H883.76V219.93H887.88V215.81Z",
    fill: "#26DEFF"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M883.75 224.04H879.63V228.16H883.75V224.04Z",
    fill: "#26DEFF"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M780.63 18.1H776.51V22.22H780.63V18.1Z",
    fill: "#7D7BFF"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M776.51 22.22H772.39V26.34H776.51V22.22Z",
    fill: "#7D7BFF"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M776.51 13.98H772.39V18.1H776.51V13.98Z",
    fill: "#7D7BFF"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M772.38 18.1H768.26V22.22H772.38V18.1Z",
    fill: "#7D7BFF"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M908.5 59.29H904.38V63.41H908.5V59.29Z",
    fill: "#6976FF"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M904.38 63.41H900.26V67.53H904.38V63.41Z",
    fill: "#6976FF"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M904.38 55.17H900.26V59.29H904.38V55.17Z",
    fill: "#6976FF"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M900.25 59.29H896.13V63.41H900.25V59.29Z",
    fill: "#6976FF"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M805.38 100.48H801.26V104.6H805.38V100.48Z",
    fill: "#008DF0"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M817.75 104.6H813.63V108.72H817.75V104.6Z",
    fill: "#008DF0"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M813.63 108.72H809.51V112.84H813.63V108.72Z",
    fill: "#008DF0"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M813.63 104.6H809.51V108.72H813.63V104.6Z",
    fill: "#52B7FF"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M813.63 100.48H809.51V104.6H813.63V100.48Z",
    fill: "#008DF0"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M809.5 112.83H805.38V116.95H809.5V112.83Z",
    fill: "#008DF0"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M809.5 108.72H805.38V112.84H809.5V108.72Z",
    fill: "#52B7FF"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M809.5 104.6H805.38V108.72H809.5V104.6Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M809.5 100.48H805.38V104.6H809.5V100.48Z",
    fill: "#52B7FF"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M809.5 96.36H805.38V100.48H809.5V96.36Z",
    fill: "#008DF0"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M805.38 108.72H801.26V112.84H805.38V108.72Z",
    fill: "#008DF0"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M805.38 104.6H801.26V108.72H805.38V104.6Z",
    fill: "#52B7FF"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M801.25 104.6H797.13V108.72H801.25V104.6Z",
    fill: "#008DF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundMain);
export default __webpack_public_path__ + "static/media/background-main.602dfeb3dffb449578ac835c5910accc.svg";
export { ForwardRef as ReactComponent };